import React from 'react';

export const PQMetricsListLegend = (
    <div className='legend-container'>
        <div className='legend-row header'>
            <div className='legend-cell narrow'></div>
            <div className='legend-cell'>Phoneme Recognition</div>
            <div className='legend-cell'>
                <div className='legend-split-cell'>Col. 1: Letter Formation with hint</div>
                <div className='legend-split-cell'>Col. 2: Letter Formation without hint</div>
            </div>
            <div className='legend-cell'>
                <div className='legend-split-cell'>Col. 1: Phonics<br></br>(words chosen at random so #'s will vary)</div>
                <div className='legend-split-cell'>Col. 2: Decoding<br></br>(Speech recognition setting must be on)</div>
            </div>
            <div className='legend-cell'>Encoding</div>
            <div className='legend-cell'>Reading Sentences<br></br>(Teacher Evaluation Mode only)</div>
        </div>
        <div className='legend-row'>
            <div className='legend-cell narrow'></div>
            <div className='legend-cell'># of correctly recognized target sounds<br></br>(out of 5)</div>
            <div className='legend-cell'># of tries to write target sound 5 times within time limit</div>
            <div className='legend-cell'>
                <div className='legend-split-cell'># of target letters formed correctly in 3 words</div>
                <div className='legend-split-cell'># of words read correctly (out of 3)</div>
            </div>
            <div className='legend-cell'># of full words written correctly (out of 3)</div>
            <div className='legend-cell'>Audio scored by teacher</div>
        </div>
    </div>
);

export const PQ2MetricsListLegend = (
    <div className='legend-container'>
        <div className='legend-row header'>
            <div className='legend-cell narrow'></div>
            <div className='legend-cell'>Phoneme Recognition</div>
            <div className='legend-cell'>Word Builder</div>
            <div className='legend-cell'>
                <div className='legend-split-cell'>Col. 1: Letter Formation with hint</div>
                <div className='legend-split-cell'>Col. 2: Letter Formation without hint</div>
            </div>
            <div className='legend-cell'>
                <div className='legend-split-cell'>Col. 1: Phonics<br></br>(words chosen at random so #'s will vary)</div>
                <div className='legend-split-cell'>Col. 2: Decoding<br></br>(Speech recognition setting must be on)</div>
            </div>
            <div className='legend-cell'>Encoding</div>
            <div className='legend-cell'>Reading Sentences<br></br>(Teacher Evaluation Mode only)</div>
        </div>
        <div className='legend-row'>
            <div className='legend-cell narrow'></div>
            <div className='legend-cell'># of correctly recognized target sounds<br></br>(out of 5)</div>
            <div className='legend-cell'># of word parts correctly<br></br>paired  on first try</div>
            <div className='legend-cell'># of tries to write target sound 10 times within time limit</div>
            <div className='legend-cell'>
                <div className='legend-split-cell'># of target letters formed correctly in 3 words</div>
                <div className='legend-split-cell'># of words read correctly (out of 3)</div>
            </div>
            <div className='legend-cell'># of full words written correctly (out of 3)</div>
            <div className='legend-cell'>Audio scored by teacher</div>
        </div>
    </div>
);



// WEBPACK FOOTER //
// ./js/components/MetricsList/MetricsListLegend.js